import {
    TDataLayer,
    TObjectMaybeWithDataLayer,
    TObjectWithDataLayer,
} from './with-data-layer.types';

function objectHasDataLayerPush(
    object?: TObjectMaybeWithDataLayer
): object is TObjectWithDataLayer {
    return typeof object?.dataLayer?.push === 'function';
}

export function withDataLayer(
    callback: (dataLayer: TDataLayer) => void,
    object: TObjectMaybeWithDataLayer = window
): void {
    if (objectHasDataLayerPush(object)) {
        callback(object.dataLayer);
    }
}
